import { Component, Input } from 'ng-metadata/core';
import './toolbar.component.scss';

/**
 * @ngdoc directive
 * @name mwToolbar
 * @module mw.components.toolbar
 *
 * @param {boolean} [is-transparent=false] - The aria-label that should be applied to the menu trigger button.
 *
 * @description
 * `<mw-toolbar>` is a component used to display a toolbar.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-toolbar>
        <div layout-align="start none" layout="row" flex>
            <md-menu class="mw-menu" md-position-mode="target-left target" md-offset="0 50">
                <mw-menu-trigger-button tooltip="{{'Open Menu' | translate}}" on-click="$mdOpenMenu($event)">{{$ctrl.filterBy | translate}}</mw-menu-trigger-button>
                <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                    <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                    <mw-menu-item type="singleselect" is-selected="$ctrl.filterBy == 'All'" on-click="$ctrl.setFilterBy('All')">All</mw-menu-item>
                    <mw-menu-item type="singleselect" is-selected="$ctrl.filterBy == 'News'" on-click="$ctrl.setFilterBy('News')">News</mw-menu-item>
                    <mw-menu-item type="singleselect" is-selected="$ctrl.filterBy == 'Social'" on-click="$ctrl.setFilterBy('Social')">Social</mw-menu-item>
                </md-menu-content>
            </md-menu>
            <div flex></div>
        </div>
        <mw-date-range-menu date-range="$ctrl.selectedDateRange" show-icon="true" compact-mode="$ctrl.isCompactMode" on-select="$ctrl.updateDateRange($event)">
        </mw-date-range-menu>
        <mw-toolbar-content-separator></mw-toolbar-content-separator>
        <md-button class="mw-button mw-button--outlined">Share</md-button>
        <mw-icon-button svg-icon="action:ic_assignment_turned_in_24px"></mw-icon-button>
        <mw-icon-button svg-icon="action:ic_settings_24px"></mw-icon-button>
      </mw-toolbar>
 * </hljs>
 *
 */
@Component({
  selector: 'mw-toolbar',
  template: `
        <md-toolbar class="mw-toolbar--inner-toolbar" flex layout="column" layout-align="center" ng-class="{ 'mw-toolbar__transparent': $ctrl.isTransparent}">
          <div class="md-toolbar-tools">
            <ng-transclude class="mw-toolbar--content" flex layout="row" layout-align="center">
            </ng-transclude>
          </div>
        </md-toolbar>
  `,
  legacy: {
    transclude: true
  }
})
export class ToolbarComponent {

  @Input('<') isTransparent: boolean = false;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/lib/components/toolbar/toolbar.component.ts